import {
  BEGIN_LOADING,
  CLEAR_LOADING,
  GET_BINDINGS,
  GET_BINDINGS_FAIL,
  GET_REVIEWS,
  GET_DISPUTE,
  APPLY_BINDING,
  CANCEL_BINDING,
  GET_RETRIEVE_LAST,
  GET_BINDING,
  RETRIEVE_ACCOUNT,
} from "../actions/types";

const initialState = {
  bindings: [],
  bindingsFail: [],
  reviews: [],
  dispute: {},
  applyBindingResult: {},
  cancelBindingResult: {},
  retrieveLast: {},
  binding: {},
  retrieveAccountResult: {},
  loading: false
};

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_BINDINGS:
      return {
        ...state,
        bindings: action.payload,
        loading: false
      };
    case GET_BINDINGS_FAIL:
      return {
        ...state,
        bindingsFail: action.payload,
        loading: false
      };
    case GET_REVIEWS:
      return {
        ...state,
        reviews: action.payload,
        loading: false
      };
    case GET_DISPUTE:
      return {
        ...state,
        dispute: action.payload,
        loading: false
      };
    case APPLY_BINDING:
      return {
        ...state,
        applyBindingResult: action.payload,
        loading: false
      };
    case CANCEL_BINDING:
      return {
        ...state,
        cancelBindingResult: action.payload,
        loading: false
      };
    case GET_RETRIEVE_LAST:
      return {
        ...state,
        retrieveLast: action.payload,
        loading: false
      };
    case GET_BINDING:
      return {
        ...state,
        binding: action.payload,
        loading: false
      };
    case RETRIEVE_ACCOUNT:
      return {
        ...state,
        retrieveAccountResult: action.payload,
        loading: false
      };
    case BEGIN_LOADING:
      return {
        ...state,
        loading: true
      };
    case CLEAR_LOADING:
      return {
        ...state,
        loading: false
      };

    default:
      return state;
  }
}
